
      import API from "!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../SKV.NSW/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../SKV.NSW/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!./au-variables.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../SKV.NSW/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../SKV.NSW/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!./au-variables.scss";
       export default content && content.locals ? content.locals : undefined;
